import ChecklistIcon from './ChecklistIcon';

export default ChecklistIcon;
